import { render } from "./HomePage.vue?vue&type=template&id=6539904a"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=6539904a&lang=css"

import exportComponent from "/Users/SQB/Projects/configurator-project/configurator/webapp/src/main/vue-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__